import { Tooltip } from "@carbon6/c6-frontend-design";
import { StatusChip } from "@/shared/ui/status";
import type { LatestProbe } from "../../domain/dataset";
import { probeFailureView } from "../../feature/probeFailureMessage";
import { probeStatusView } from "../../feature/probeStatus";
import styles from "./LatestProbeChip.module.css";

type LatestProbeChipProps = {
  probe: LatestProbe | null;
};

/**
 * 목록의 최근 Probe 상태 칩. 표의 칸과 카드가 같이 쓴다.
 *
 * Probe 가 없으면 `—` 다. 실패면 사유 요약을 툴팁에 둔다. 사유 전문과 재시도는 상세 창의 Probe 이력이 가진다.
 */
export function LatestProbeChip({ probe }: LatestProbeChipProps) {
  if (probe === null) {
    // `aria-label` 은 일반 span 에 붙지 않는다. 화면에는 `—` 만, 스크린 리더에는 문장만 읽힌다.
    return (
      <span>
        <span aria-hidden="true">—</span>
        <span className={styles.hidden}>Probe 없음</span>
      </span>
    );
  }
  const view = probeStatusView(probe.state);
  const chip = <StatusChip tone={view.tone}>{view.label}</StatusChip>;
  if (probe.state !== "failed") {
    return chip;
  }
  return <Tooltip content={probeFailureView(probe.failureCode).message}>{chip}</Tooltip>;
}
